export { default } from './HiddenInput';
